<template>
  <div class="servicesButtonWrapper">
    <div class="buttonContent">
      <div style="display: flex; flex-direction: column; align-items: center">
        <div class="servicesButton" @click="setDisplay(true)">
          <i class="el-icon-chat-dot-square" />
        </div>
        联系客服
      </div>
    </div>
    <div
      class="servicesButtonContent"
      :style="{ display: display ? 'flex' : 'none' }"
    >
      <i class="el-icon-close close" @click="setDisplay(false)" />
      <div class="title">
        <img alt="logo" src="../../assets/statics/logo.png" class="imgLogo" />
        <p>客户服务顾问</p>
      </div>
      <p class="desc">有任何商务需求和意见反馈，欢迎联系我们</p>
      <img
        alt="qr-code"
        src="../../assets/statics/images/service.jpg"
        class="servicesButtonImage"
      />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return { display: false };
  },
  methods: {
    setDisplay(display) {
      this.display = display;
    },
  },
};
</script>
<style lang="less" scoped>
.servicesButtonWrapper {
  display: flex;
  z-index: 999;

  .buttonContent {
    display: flex;
    flex-direction: column;
    width: 110px;
    height: 80px;
    position: fixed;
    right: 36px;
    bottom: 40px;
    align-items: center;
    cursor: pointer;

    > :nth-child(2n) {
      margin-top: 10px;
    }
  }

  .title {
    font-weight: 700;
    color: white;
    font-size: 14px;
  }

  .desc {
    font-size: 12px;
    line-height: 18px;
    padding: 0 24px;
    margin-top: 24px;
  }

  .servicesButtonImage {
    width: 100px;
    height: 100px;
  }

  .servicesButtonContent {
    position: fixed;
    right: 36px;
    bottom: 20px;
    flex-direction: column;
    width: 210px;
    height: 240px;
    align-items: center;
    border-bottom-left-radius: 5px;
    display: none;
    border-radius: 6px;
    background-color: #eeeff1;
    color: #757575;
    text-align: center;
    font-size: 12px;

    .title {
      width: 100%;
      background-color: #000000;
      display: flex;
      align-items: center;
      height: 44px;
      justify-content: center;
      font-size: 14px;
      border-radius: 6px 0 0;
      p {
        margin: 0;
        margin-left: 12px;
      }
      .imgLogo {
        width: 35%;
        filter: brightness(0) invert(1);
      }
    }
  }

  .servicesButton {
    width: 38px;
    height: 38px;
    background-color: #726f8a;
    color: white;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-radius: 50%;
    margin-bottom: 8px;

    justify-content: center;
    align-items: center;
    font-size: 18px;
    display: flex;
    cursor: pointer;
  }

  .close {
    color: #000000;
    position: absolute;
    right: 0;
    top: -24px;
    font-size: 18px;
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/login/ServicesButton.vue